import React from 'react';
import { Link } from 'react-router-dom';
import ParticlesAuth from './ParticlesAuth';
import error from '../../../assets/images/error.svg';
import { Button } from '../../../components/ui/button';
import { Home } from 'lucide-react';

const Error404 = () => {
    document.title = 'Página não encontrada | Ad Pulse';
    return (
        <ParticlesAuth>
            <div className="w-full px-4 py-10 md:py-16">
                <div className="mx-auto w-full max-w-lg text-center">
                    <div className="pt-4">
                        <img src={error} alt="Erro 404" className="mx-auto max-w-xs animate-bounce" />
                    </div>
                    <div className="-mt-4">
                        <h1 className="text-8xl font-medium tracking-tight text-foreground">404</h1>
                        <h3 className="mt-2 text-lg font-semibold uppercase text-foreground">
                            Desculpe, página não encontrada 😭
                        </h3>
                        <p className="mt-2 text-sm text-muted-foreground">
                            A página que você está procurando não está disponível!
                        </p>
                        <div className="mt-6">
                            <Button asChild className="bg-primary hover:bg-primary/90 border-0">
                                <Link to="/">
                                    <Home className="mr-1 size-4" />
                                    Voltar para a página inicial
                                </Link>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </ParticlesAuth>
    );
};

export default Error404;
